module.exports = __webpack_public_path__ + "img/MarketPlaces.6ecea91c.svg";